module.exports = __webpack_public_path__ + "images/725f63acf96b6ab76d47735223200e24-MSW_LineArt_Numbers(5)_slide19.png";